<template>
  <div> 
    <div v-if="is_super_admin">
    <div >
      <el-button type="primary" icon="el-icon-plus" style="margin-block: 16px; margin-left: 16px;"
      size="mini" plain
      @click="add_coupon_type"
      >新建优惠券</el-button>
    </div>
    
    <div>
      <el-alert
        title="提示"
        style="height:50px"
        type="warning"
        description="优惠卷名称不可重复,不可修改,如需修改某活动名,请删除后重新添加,优惠券抵扣方式选择扣,只可配置一种抵扣方式"
        show-icon
        close-text="我知道了"
        >
      </el-alert>
    </div>

    <div style="margin-top: 20px">
      <el-table
        :data="l_coupon_type_table_data"
        style="width: 100%;margin-bottom: 20px;"
        :header-cell-style="{'background-color': '#eff3f8', color: '#606266'}"
        default-expand-all
        border
        >

        <el-table-column
        prop="coupon_type_id"
        label="优惠券类型ID"
        align="center"
        >
        </el-table-column>

        <el-table-column
          prop="coupon_name"
          label="优惠券名称"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop="coupon_mode"
          label="抵扣方式"
          align="center"
          >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.coupon_mode == 1">现金抵扣</el-tag>
            <el-tag v-else>折扣方式</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="coupon_amount"
          label="抵扣金额"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop="coupon_discount"
          label="折扣率"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop="coupon_detail"
          label="说明"
          align="center"
          >
        </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          >
          <template slot-scope="scope">
            <el-button plain round icon="el-icon-edit" type="success" size="small" @click="on_edit_coupon_type(scope.row)">编辑</el-button>
            <el-button round icon="el-icon-delete" type="danger" size="small" @click="on_delete_coupon_type(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false" style="padding: 12px 16px;">
        
        <div slot="title" class="dialog-title">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
            <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
            <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
        </div>

        <el-form :model="d_form" ref="d_form" label-width="100px" @class="demo-d_form">
          <el-form-item label="优惠券名称" prop="coupon_name">
            <el-input v-model="d_form.coupon_name" ></el-input>
          </el-form-item>

          <el-form-item label="抵扣方式" prop="coupon_mode">
            <el-radio v-model="d_form.coupon_mode" label="1">现金抵扣</el-radio>
            
            <el-radio v-model="d_form.coupon_mode" label="2">折扣</el-radio>
          </el-form-item>

          <el-form-item v-if="d_form.coupon_mode == 1" label="抵扣金额" prop="coupon_mode">
            <el-input-number v-model="d_form.coupon_amount" :precision="2" :step="5"></el-input-number>
          </el-form-item>

          <el-form-item v-if="d_form.coupon_mode == 2" label="折扣率" prop="coupon_mode">
            <el-input-number v-model="d_form.coupon_discount" :precision="2" :step="0.05" :max="0.99"></el-input-number>
          </el-form-item>

          <el-form-item label="优惠券说明" prop="coupon_detail">
            <el-input v-model="d_form.coupon_detail"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="on_submit()">{{ s_btn_name }}</el-button>
            <el-button @click="on_cancel">取消</el-button> 
          </el-form-item>

        </el-form>
      </el-dialog>
      
    </div>

    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  // 优惠券类型管理
  name: "CourseTypeSystem",
  data() {
    return {
      l_coupon_type_table_data: [],

      // 
      b_show_dialog: false,
      i_diaglog_type: 1,
      b_show_fullscreen: false,
      s_dialog_name: '',
      s_btn_name: '',
      d_form: {},
      is_super_admin: false,
    };
  },

  mounted(){
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    // 刷新表单数据
    this.refresh_coupon_type_table_data()
  
  },
  
  methods: {
    // 刷新表单数据
    async refresh_coupon_type_table_data(){
      let url = '/api/coupon_type/'
      let res = await this.$axios.get(url)
      console.log(res)

      this.l_coupon_type_table_data = res.data
      console.log(this.l_coupon_type_table_data)
      
    },

    // 新增活动类型
    add_coupon_type(){
      this.s_dialog_name = '新增优惠券类型'
      this.b_show_dialog = true
      this.s_btn_name = '确定'
      this.i_diaglog_type = 1
      this.d_form = {}

    },

    // 编辑活动类型
    on_edit_coupon_type(row){
      this.s_dialog_name = '编辑优惠券类型'
      this.b_show_dialog = true
      this.s_btn_name = '确定'
      this.i_diaglog_type = 2
      this.d_form = row
    },

    // 删除活动类型
    on_delete_coupon_type(row){
      this.$confirm('此操作将永久删除该优惠券类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.on_delete_submit(row)
       
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },


    // 执行删除请求
    async on_delete_submit(row){
      let res = await this.$axios.delete('/api/coupon_type/' + row.coupon_type_id + '/')
      console.log(res)
      if (res.status === 204){
        this.refresh_coupon_type_table_data()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }else {
        this.$message({
          type: 'error',
          message: '删除失败!请检查是否已关联其他活动'
        });
      }
    },

    // 提交表单
    on_submit(){
      // 判断是更新还是新增
      if(this.i_diaglog_type == 1){
        this.add_coupon_type_submit()
      }else{
        this.edit_coupon_type_submit()
      }
      
    },

    // 请求前处理数据
    before_request_data(data){
      if(data.coupon_mode == 1){
        data.coupon_discount = null
      }else{
        data.coupon_amount = null
      }
      return data
    },

    // 新建活动类型提交
    async add_coupon_type_submit(){
      this.before_request_data(this.d_form)
      let url = '/api/coupon_type/'
      let res = await this.$axios.post(url, this.d_form)
      console.log(res)
      this.b_show_dialog = false
      this.refresh_coupon_type_table_data()
    },

    // 编辑活动类型提交
    async edit_coupon_type_submit(){
      this.before_request_data(this.d_form)
      let url = '/api/coupon_type/' + this.d_form.coupon_type_id + '/'
      let res = await this.$axios.put(url, this.d_form)
      console.log(res)
      this.b_show_dialog = false
      this.refresh_coupon_type_table_data()
    },

    // 取消表单
    on_cancel(){
      this.b_show_dialog = false
    },
  },
  
  
};
</script>

<style>
</style>

